import { AsyncPipe } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    inject
} from "@angular/core";
import { TableComponent } from "@components/table/table.component";
import { GridOptions } from "ag-grid-community";
import { orderBy } from "lodash";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { AgGridTableService } from "~app/common/components/table/ag-grid-table.service";
import { RaskColumn } from "~app/common/components/table/models/rask-column";
import { SandningsloggItemModel, SandningsloggViewModel } from "../../produktion.models";
import { SandningsloggTexts } from "../sandningslogg.texts";

@Component({
    selector: "rask-search-result",
    templateUrl: "./search-result.component.html",
    styleUrls: ["./search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TableComponent,
        AsyncPipe
    ]
})
export class SearchResultComponent implements OnInit {

    @Input() set data(val: SandningsloggItemModel[]) {
        this.dataSrc.next(val);
    }

    searchResult: SandningsloggViewModel[];
    texts = SandningsloggTexts.texts;

    gridOptions: GridOptions = {
        domLayout: "normal"
    };

    tableColumns = [
        {
            headerName: this.texts.Gpxnr,
            field: "sdcGpxnummer",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 150,
            resizable: true
        },
        {
            headerName: this.texts.Maskinnr,
            field: "maskinnummer",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 150,
            resizable: true
        },
        {
            headerName: this.texts.Maskintyp,
            field: "maskintyp",
            filter: true,
            sortable: true,
            type: "span",
            width: 30,
            minWidth: 30,
            maxWidth: 150,
            resizable: true
        },
        {
            headerName: this.texts.Fabrikat,
            field: "fabrikat",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 150,
            resizable: true
        },
        {
            headerName: this.texts.Filnamn,
            field: "filnamn",
            filter: true,
            sortable: true,
            type: "span",
            width: 100,
            minWidth: 100,
            initialWidth: 100,
            resizable: true
        },
        {
            headerName: this.texts.Filtyp,
            field: "filtyp",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 100,
            resizable: true
        },
        {
            headerName: this.texts.Version,
            field: "version",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 100,
            resizable: true
        },
        {
            headerName: this.texts.Filskapad,
            field: "filskapad",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 180,
            resizable: true
        },
        {
            headerName: this.texts.Kuvertskapa,
            field: "skickadTidpunkt",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 180,
            resizable: true
        },
        {
            headerName: this.texts.Kvittoinlast,
            field: "kvitteratTidpunkt",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 180,
            resizable: true
        },
        {
            headerName: this.texts.Status,
            field: "status",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 150,
            resizable: true
        },
        {
            headerName: this.texts.Sender,
            field: "sender",
            filter: true,
            sortable: true,
            type: "span",
            width: 50,
            minWidth: 50,
            maxWidth: 150,
            resizable: true
        }
    ] as RaskColumn[];

    protected searchResult$: Observable<SandningsloggViewModel[]>;
    private readonly dataSrc = new Subject<SandningsloggItemModel[]>();
    private readonly agGridService = inject(AgGridTableService);
    ngOnInit(): void {
        this.gridOptions = {
            ...this.agGridService.getDefaultOptions(true),
            domLayout: "normal"
        };

        this.searchResult$ = this.dataSrc.pipe(
            map(this.onSearchResultChanged)
        );
    }

    onSearchResultChanged(result: SandningsloggItemModel[]): SandningsloggViewModel[] {
        const res = result.map(y => new SandningsloggViewModel(y));
        return orderBy(res, g => g.skickadTidpunkt, "desc");
    }
}
